function Kazakhstan({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1436)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#338AF3"/>
        <path d="M25.0435 16.174H6.95654C6.95654 17.4226 8.0441 18.4348 9.29267 18.4348H9.21742C9.21742 19.6835 10.2296 20.6957 11.4783 20.6957C11.4783 21.9444 12.4905 22.9566 13.7392 22.9566H18.2609C19.5096 22.9566 20.5218 21.9444 20.5218 20.6957C21.7705 20.6957 22.7827 19.6835 22.7827 18.4348H22.7074C23.9558 18.4348 25.0435 17.4226 25.0435 16.174V16.174Z" fill="#FFDA44"/>
        <path d="M22.2609 13.2173C22.2609 16.6751 19.4578 19.4782 16 19.4782C12.5422 19.4782 9.73914 16.6751 9.73914 13.2173" fill="#338AF3"/>
        <path d="M20.7821 13.2174L18.8281 14.1366L19.8686 16.0291L17.7468 15.6232L17.4779 17.7667L16 16.1901L14.522 17.7667L14.2531 15.6232L12.1313 16.029L13.1718 14.1365L11.2178 13.2174L13.1718 12.2983L12.1313 10.4058L14.2531 10.8117L14.522 8.66821L16 10.2448L17.478 8.66821L17.7468 10.8117L19.8687 10.4058L18.8281 12.2983L20.7821 13.2174Z" fill="#FFDA44"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Kazakhstan;
